import React from "react";
import ToggleButton from "../../components/common/inputs/toggles/Toggle";
import PrimaryButton from "../../components/common/buttons/PrimaryButton";

const Settings: React.FC = () => {
  return (
    <div className="container mx-auto p-6">
      <h2 className="text-3xl font-bold mb-6">Admin Settings</h2>

      <div className="bg-white shadow-md rounded-lg overflow-hidden mb-6">
        <div className="p-6">
          <div className="grid gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Feature Toggle
              </label>
              <ToggleButton onValueChange={() => {}} value={false} />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Another Feature
              </label>
              <ToggleButton onValueChange={() => {}} value={true} />
            </div>{" "}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Submit Changes
              </label>
              <div className="flex w-min">
                <PrimaryButton disabled={true}>Save</PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
